export default __webpack_public_path__ + "static/media/schedule.fedc8cf4.jpeg";